import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { companyLogo, companyLogoOriginal } from "../../assets/imgExport";
import { useSelector } from "react-redux";
import { getIsSmallScreen } from "../../features/app/appSlice";
import {
  IconMenu,
  IconClose,
  IconLocation2,
  IconEmail2,
} from "../../assets/svgExport";
import styles from "./Header.module.scss";

export default function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isSmallScreen = useSelector(getIsSmallScreen);
  const menuRef = useRef<HTMLDivElement>(null);

  function isCurrentPage(path: string) {
    return (
      "hover:text-main-light text-sm inline-block my-auto " +
      (currentPath.includes(path) ? `text-sm text-main-light ` : "") +
      " " +
      (path === "contact"
        ? `${
            isSmallScreen ? "-ml-4 -mr-4" : ""
          } border border-main-dark px-4 py-2 hover:border-main-light`
        : "")
    );
  }

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isMenuOpen]);

  return (
    <header
      className={`fixed top-0  left-0 w-full z-[999999] flex justify-between items-center pl-8 ${
        isSmallScreen ? "pr-4" : "pr-8"
      } py-2 transition-all duration-300 ${"bg-white/100 border-b"} ${
        styles.header
      }`}
      style={{
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <div>
        <NavLink to="/">
          <img
            className="w-24"
            src={companyLogoOriginal}
            alt="Venti Maris company logo"
          />
        </NavLink>
      </div>

      {isSmallScreen ? (
        <>
          {isMenuOpen && (
            <div
              className="fixed inset-0 w-screen h-screen bg-black opacity-50 z-[999997]"
              onClick={() => setIsMenuOpen(false)}
            ></div>
          )}
          <div className="relative" ref={menuRef}>
            <button onClick={() => setIsMenuOpen(true)} type="button">
              <IconMenu style={{ fill: "#0e1856" }} width={24} height={24} />
            </button>
            <div
              className={`fixed right-0 top-0 border-l bg-white shadow-lg w-60 h-screen p-6 pt-10 z-[999999] transition-transform duration-300 ${
                isMenuOpen ? "translate-x-0" : "translate-x-full"
              }`}
            >
              <button
                className="absolute right-2 top-2"
                onClick={() => setIsMenuOpen(false)}
              >
                <IconClose fill="#aaa" width={16} height={16} />
              </button>
              <NavLink to="/" onClick={() => setIsMenuOpen(false)}>
                <img
                  className="w-32"
                  src={companyLogoOriginal}
                  alt="Venti Maris company logo"
                />
              </NavLink>
              <ul className="flex flex-col gap-4 px-1 my-6 border-y py-8 text-main-dark font-light">
                <li className={`${isCurrentPage("about-us")}`}>
                  <NavLink to="/about-us" onClick={() => setIsMenuOpen(false)}>
                    About Us
                  </NavLink>
                </li>
                <li className={`${isCurrentPage("services")}`}>
                  <NavLink to="/services" onClick={() => setIsMenuOpen(false)}>
                    Services
                  </NavLink>
                </li>
                <li className={`${isCurrentPage("sustainability")}`}>
                  <NavLink
                    to="/sustainability"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Sustainability
                  </NavLink>
                </li>
                <li className={`${isCurrentPage("careers")}`}>
                  <NavLink to="/careers" onClick={() => setIsMenuOpen(false)}>
                    Careers
                  </NavLink>
                </li>
                <li className={`${isCurrentPage("contact")}`}>
                  <NavLink to="/contact" onClick={() => setIsMenuOpen(false)}>
                    Contact
                  </NavLink>
                </li>
              </ul>
              <div className="flex gap-2 items-center">
                <IconEmail2 width={12} height={12} />
                <a
                  className="text-sm text-main-dark/60"
                  href="mailto:contact@ventimaris.com"
                >
                  contact@ventimaris.com
                </a>
              </div>
            </div>
          </div>
        </>
      ) : (
        <nav>
          <ul
            className={`flex gap-8 whitespace-nowrap ${"text-main-dark font-light"} `}
          >
            <li className={`${isCurrentPage("about-us")}`}>
              <NavLink to="/about-us">About Us</NavLink>
            </li>
            <li className={`${isCurrentPage("services")}`}>
              <NavLink to="/services">Services</NavLink>
            </li>
            <li className={`${isCurrentPage("sustainability")}`}>
              <NavLink to="/sustainability">Sustainability</NavLink>
            </li>
            <li className={`${isCurrentPage("careers")}`}>
              <NavLink to="/careers">Careers</NavLink>
            </li>
            <li className={`${isCurrentPage("contact")}`}>
              <NavLink to="/contact">Contact</NavLink>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
